module.exports = __webpack_public_path__ + "img/logo-mini-color.99f2cafe.png";